import React from 'react';
import { heroData } from '../data/mock';
import { Button } from './ui/button';
import { ChevronDown, Sparkles, Crown } from 'lucide-react';
import SparklingGold from './SparklingGold';

const HeroSection = ({ onCTAClick }) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-black via-black to-gray-900">
      {/* Goldene Strähne Design-Elemente - subtiler */}
      <div className="absolute inset-0 z-0 overflow-hidden opacity-40">
        <div className="absolute top-0 bottom-0 left-[15%] w-px bg-gradient-to-b from-gold/0 via-gold/20 to-gold/0"></div>
        <div className="absolute top-0 bottom-0 left-[30%] w-px bg-gradient-to-b from-gold/0 via-gold/15 to-gold/0"></div>
        <div className="absolute top-0 bottom-0 left-[70%] w-px bg-gradient-to-b from-gold/0 via-gold/15 to-gold/0"></div>
        <div className="absolute top-0 bottom-0 right-[15%] w-px bg-gradient-to-b from-gold/0 via-gold/20 to-gold/0"></div>
      </div>

      {/* Sparkling Gold Effects - subtiler */}
      <SparklingGold density="low" />

      {/* Content Container */}
      <div className="container mx-auto px-6 lg:px-12 relative z-10 pt-32 lg:pt-24">
        <div className="max-w-6xl mx-auto text-center">
          
          {/* Main Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-7xl xl:text-8xl font-bold mb-8 lg:mb-10 leading-[1.1] tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-gold via-yellow-300 to-gold animate-gradient">
            {heroData.headline}
          </h1>

          {/* Subheadline */}
          <p className="text-lg sm:text-xl lg:text-2xl text-white/90 mb-10 lg:mb-12 leading-relaxed font-light max-w-4xl mx-auto">
            {heroData.subheadline}
          </p>

          {/* Trust Elements */}
          <div className="flex flex-wrap justify-center items-center gap-4 lg:gap-8 mb-12 lg:mb-16">
            {heroData.trustElements.map((element, index) => (
              <div 
                key={index}
                className="flex items-center gap-2 text-white/70 text-sm lg:text-base"
              >
                <div className="w-1.5 h-1.5 rounded-full bg-gold"></div>
                <span className="font-medium">{element}</span>
              </div>
            ))}
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 lg:gap-6 justify-center items-center mb-16 lg:mb-20">
            <Button 
              onClick={onCTAClick}
              size="lg"
              className="bg-accent-red hover:bg-accent-red/90 text-white px-10 lg:px-12 py-6 lg:py-7 rounded-full text-base lg:text-lg font-semibold tracking-wide transition-all hover:scale-105 shadow-2xl shadow-accent-red/30 min-w-[240px]"
            >
              {heroData.ctaPrimary}
            </Button>
            <Button 
              onClick={onCTAClick}
              size="lg"
              variant="outline"
              className="border-2 border-gold text-gold hover:bg-gold hover:text-black px-10 lg:px-12 py-6 lg:py-7 rounded-full text-base lg:text-lg font-semibold tracking-wide transition-all hover:scale-105 min-w-[240px]"
            >
              {heroData.ctaSecondary}
            </Button>
          </div>

          {/* Scroll Indicator */}
          <div className="mt-20 lg:mt-24 animate-bounce">
            <button 
              onClick={() => document.getElementById('target-audience')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-gold/60 hover:text-gold transition-colors"
              aria-label="Scroll down"
            >
              <ChevronDown size={32} />
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black to-transparent pointer-events-none"></div>
    </section>
  );
};

export default HeroSection;
